// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"163a3b9f","326":"f694c647","473":"f694c647"}[chunkId] + ".chunk.css";
};